import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {SideBarModuleConfig} from "./side-bar-module.config";
import {SideBarModuleState} from "./models/side-bar-module.state";

export class SideBarModuleStore extends BaseMobxStore {
  static injectables = [SideBarModuleConfig, SideBarModuleState];
}

